// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets de los botones
 * @param {*} scene
 */
export function cargaAssetsBotones(scene) {
  /*/=======================================================================================\*\
  ||                               BOTON SUMAR                                               ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonSumarDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton1SumarDesactivadoResized.png'
  );
  scene.load.image(
    'botonSumarEstatico',
    ROUTES.rutaBlackJackBotones + '/boton1SumarEstaticoResized.png'
  );
  scene.load.image(
    'botonSumarHover',
    ROUTES.rutaBlackJackBotones + '/boton1SumarHoverResized.png'
  );
  scene.load.image(
    'botonSumarPressed',
    ROUTES.rutaBlackJackBotones + '/boton1SumarPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON RESTAR                                              ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonRestarDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton2RestarDesactivadoResized.png'
  );
  scene.load.image(
    'botonRestarEstatico',
    ROUTES.rutaBlackJackBotones + '/boton2RestarEstaticoResized.png'
  );
  scene.load.image(
    'botonRestarHover',
    ROUTES.rutaBlackJackBotones + '/boton2RestarHoverResized.png'
  );
  scene.load.image(
    'botonRestarPressed',
    ROUTES.rutaBlackJackBotones + '/boton2RestarPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON BORRAR                                              ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonBorrarDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton2BorrarDesactivadoResized.png'
  );
  scene.load.image(
    'botonBorrarEstatico',
    ROUTES.rutaBlackJackBotones + '/boton2BorrarEstaticoResized.png'
  );
  scene.load.image(
    'botonBorrarHover',
    ROUTES.rutaBlackJackBotones + '/boton2BorrarHoverResized.png'
  );
  scene.load.image(
    'botonBorrarPressed',
    ROUTES.rutaBlackJackBotones + '/boton2BorrarPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON JUGAR                                               ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonJugarDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton3JugarDesactivadoResized.png'
  );
  scene.load.image(
    'botonJugarEstatico',
    ROUTES.rutaBlackJackBotones + '/boton3JugarEstaticoResized.png'
  );
  scene.load.image(
    'botonJugarHover',
    ROUTES.rutaBlackJackBotones + '/boton3JugarHoverResized.png'
  );
  scene.load.image(
    'botonJugarPressed',
    ROUTES.rutaBlackJackBotones + '/boton3JugarPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON REPETIR                                              ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonRepetirDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton4RepetirDesactivadoResized.png'
  );
  scene.load.image(
    'botonRepetirEstatico',
    ROUTES.rutaBlackJackBotones + '/boton4RepetirEstaticoResized.png'
  );
  scene.load.image(
    'botonRepetirHover',
    ROUTES.rutaBlackJackBotones + '/boton4RepetirHoverResized.png'
  );
  scene.load.image(
    'botonRepetirPressed',
    ROUTES.rutaBlackJackBotones + '/boton4RepetirPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON DIVIDIR MANO                                        ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonDividirManoDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton5DividirManoDesactivadoResized.png'
  );

  scene.load.image(
    'botonDividirManoEstatico',
    ROUTES.rutaBlackJackBotones + '/boton5DividirManoEstaticoResized.png'
  );
  scene.load.image(
    'botonDividirManoHover',
    ROUTES.rutaBlackJackBotones + '/boton5DividirManoHoverResized.png'
  );
  scene.load.image(
    'botonDividirManoPressed',
    ROUTES.rutaBlackJackBotones + '/boton5DividirManoPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON DOBLAR APUESTA                                      ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonDoblarApuestaDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton6DoblarApuestaDesactivadoResized.png'
  );

  scene.load.image(
    'botonDoblarApuestaEstatico',
    ROUTES.rutaBlackJackBotones + '/boton6DoblarApuestaEstaticoResized.png'
  );
  scene.load.image(
    'botonDoblarApuestaHover',
    ROUTES.rutaBlackJackBotones + '/boton6DoblarApuestaHoverResized.png'
  );
  scene.load.image(
    'botonDoblarApuestaPressed',
    ROUTES.rutaBlackJackBotones + '/boton6DoblarApuestaPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON PEDIR CARTA                                         ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonPedirCartaDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton7PedirCartaDesactivadoResized.png'
  );
  scene.load.image(
    'botonPedirCartaEstatico',
    ROUTES.rutaBlackJackBotones + '/boton7PedirCartaEstaticoResized.png'
  );
  scene.load.image(
    'botonPedirCartaHover',
    ROUTES.rutaBlackJackBotones + '/boton7PedirCartaHoverResized.png'
  );
  scene.load.image(
    'botonPedirCartaPressed',
    ROUTES.rutaBlackJackBotones + '/boton7PedirCartaPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON PLANTARME                                           ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonPlantarmeDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton8PlantarmeDesactivadoResized.png'
  );
  scene.load.image(
    'botonPlantarmeEstatico',
    ROUTES.rutaBlackJackBotones + '/boton8PlantarmeEstaticoResized.png'
  );
  scene.load.image(
    'botonPlantarmeHover',
    ROUTES.rutaBlackJackBotones + '/boton8PlantarmeHoverResized.png'
  );
  scene.load.image(
    'botonPlantarmePressed',
    ROUTES.rutaBlackJackBotones + '/boton8PlantarmePressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON SI (SEGURO BLACK JACK)                              ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonSiSeguroDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton9SiSeguroDesactivadoResized.png'
  );
  scene.load.image(
    'botonSiSeguroEstatico',
    ROUTES.rutaBlackJackBotones + '/boton9SiSeguroEstaticoResized.png'
  );
  scene.load.image(
    'botonSiSeguroHover',
    ROUTES.rutaBlackJackBotones + '/boton9SiSeguroHoverResized.png'
  );
  scene.load.image(
    'botonSiSeguroPressed',
    ROUTES.rutaBlackJackBotones + '/boton9SiSeguroPressedResized.png'
  );

  /*/=======================================================================================\*\
  ||                               BOTON NO (SEGURO BLACK JACK)                              ||
  \*\=======================================================================================/*/
  scene.load.image(
    'botonNoSeguroDesactivado',
    ROUTES.rutaBlackJackBotones + '/boton10NoSeguroDesactivadoResized.png'
  );
  scene.load.image(
    'botonNoSeguroEstatico',
    ROUTES.rutaBlackJackBotones + '/boton10NoSeguroEstaticoResized.png'
  );
  scene.load.image(
    'botonNoSeguroHover',
    ROUTES.rutaBlackJackBotones + '/boton10NoSeguroHoverResized.png'
  );
  scene.load.image(
    'botonNoSeguroPressed',
    ROUTES.rutaBlackJackBotones + '/boton10NoSeguroPressedResized.png'
  );
}
